import { Card, SimpleGrid, Skeleton, Stack } from '@mantine/core'

/**
 * Loading in the shape of the content (UX spec §4.5), inside the page so its header and back link stay: a row of stat
 * tiles, then [cards] cards, or [rows] list rows.
 */
export function PageSkeleton(props: { tiles?: number; cards?: number; rows?: number; label?: string }) {
  return (
    <Stack gap="md" aria-busy="true" aria-label={props.label ?? 'Loading'}>
      {(props.tiles ?? 0) > 0 && (
        <SimpleGrid cols={{ base: 2, sm: Math.min(4, props.tiles ?? 4) }}>
          {Array.from({ length: props.tiles ?? 0 }, (_, index) => (
            <Card key={index}>
              <Skeleton height={12} width="50%" mb={12} />
              <Skeleton height={24} width="70%" />
            </Card>
          ))}
        </SimpleGrid>
      )}
      {Array.from({ length: props.cards ?? 0 }, (_, index) => (
        <Card key={index}>
          <Skeleton height={16} width="30%" mb={16} />
          <Skeleton height={160} />
        </Card>
      ))}
      {Array.from({ length: props.rows ?? 0 }, (_, index) => (
        <Skeleton key={index} height={44} />
      ))}
    </Stack>
  )
}
